import { render } from "./SearchBar.vue?vue&type=template&id=797a8c4c&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=797a8c4c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-797a8c4c"

export default script